const jlysjz = [{
        path: 'jlys_jlyspz',
        name: 'jlys_jlyspz',
        component: () =>
            import ("@/components/jlysjz/jlyspz"),
        meta: { title: '考核配置', requireAuth: true, keepAlive: true, permission: true },
    },
    {
        path: 'jlys_jlysjl',
        name: 'jlys_jlysjl',
        component: () =>
            import ("@/components/jlysjz/jlysjl"),
        meta: { title: '个人考核记录', requireAuth: true, keepAlive: true, permission: true },
    },
       {
        path: 'laohe',
        name: 'laohe',
        component: () =>
            import ("@/components/jlysjz/laohe"),
        meta: { title: '考核页面', requireAuth: true, keepAlive: true, permission: true },
    },
    {
        path: 'kaoheye',
        name: 'kaoheye',
        component: () =>
            import ("@/components/jlysjz/kaohejiangcheng"),
        meta: { title: '考核奖惩页', requireAuth: true, keepAlive: true, permission: true },
    },
    {
        path: 'jlysjz',
        name: 'jlysjz',
        component: () =>
            import ("@/components/jlysjz/jlysjz"),
        meta: { title: '奖励约束机制', requireAuth: true, keepAlive: true, permission: true },
    },

]
export default jlysjz


// WEBPACK FOOTER //
// ./src/router/jlysjz.js